import { render, staticRenderFns } from "./BreakdownChart.vue?vue&type=template&id=7c8b3b09&lang=pug"
import script from "./BreakdownChart.vue?vue&type=script&lang=js"
export * from "./BreakdownChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports